import {
  ClerkLoaded,
  ClerkLoading,
  ClerkProvider,
  SignIn,
} from "@clerk/react-router";
import {
  clerkMiddleware,
  getAuth,
  rootAuthLoader,
} from "@clerk/react-router/server";
import { Loader2 } from "lucide-react";
import * as ReactRouter from "react-router";
import { getClerkLocalization } from "~/app/lib/locale";
import * as Paths from "~/app/paths";

export const middleware = [clerkMiddleware()];

export async function loader(args: ReactRouter.LoaderFunctionArgs) {
  const { userId } = await getAuth(args);
  if (userId) {
    throw ReactRouter.redirect(Paths.app());
  }

  return rootAuthLoader(args, async () => null);
}

export default function LoginPage() {
  const loaderData = ReactRouter.useLoaderData<typeof loader>();
  const rootLoaderData = ReactRouter.useRouteLoaderData("root");

  return (
    <ClerkProvider
      loaderData={loaderData}
      signInUrl={Paths.login()}
      signUpUrl={Paths.signUp()}
      signUpFallbackRedirectUrl={Paths.app()}
      signInFallbackRedirectUrl={Paths.app()}
      localization={getClerkLocalization(rootLoaderData?.locale)}
    >
      <div className="flex min-h-screen items-center justify-center p-4">
        <ClerkLoading>
          <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
        </ClerkLoading>
        <ClerkLoaded>
          <SignIn
            path={Paths.login()}
            routing="path"
            fallbackRedirectUrl={Paths.app()}
          />
        </ClerkLoaded>
      </div>
    </ClerkProvider>
  );
}
